import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VideoConferencePage from './pages/VideoConferencePage';
import './App.css';

function App() {
  const accessToken = useAuthStore((state) => state.accessToken);
  const restoreSession = useAuthStore((state) => state.restoreSession);

  useEffect(() => {
    // Restore session from localStorage on app load
    // This will load the token that was stored by redirect.html
    restoreSession();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        
        {/* Video conference room - main page */}
        <Route 
          path="/rooms" 
          element={accessToken ? <VideoConferencePage /> : <Navigate to="/login" />} 
        />
        <Route 
          path="/room/:roomId" 
          element={accessToken ? <VideoConferencePage /> : <Navigate to="/login" />} 
        />
        
        {/* Default redirect to rooms/video */}
        <Route path="/" element={<Navigate to={accessToken ? "/rooms" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;